import logo from '../img/logo_utesc.png';

export default function Menu({ component: Component }) {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container d-flex justify-content-center">
          <div className="navbar-brand user-select-none">
            <img
              src={ logo }
              alt=""
              width="30"
              height="30"
              className="d-inline-block align-top imgNavBar"
            />
            &nbsp;Sistema de empleados UTESC
          </div>
        </div>
      </nav>
      <div className='container-fluid'>
        <Component/>
      </div>
    </>
  );
}
